<template>
   <div class="card mb-0 usuario-card" ref="usuario">
      <div class="card-body">
         <!-- Menu dropdown -->
         <div class="d-flex justify-content-end position-absolute" style="right: 10px; top: 10px; z-index: 10;">
            <div class="dropdown">
               <button class="btn btn-sm btn-theme" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-ellipsis-v"></i>
               </button>
               <ul class="dropdown-menu dropdown-menu-right">
                  <li class="cursor-pointer"><a class="dropdown-item" @click="editar"><i class="fas fa-edit mr-2"></i>Editar</a></li>
                  <li class="cursor-pointer" v-if="dadosUsuario.usuarioPermissoes.includes('Alterar senha')">
                     <a class="dropdown-item" @click="senha"><i class="fas fa-key mr-2"></i>Alterar senha</a>
                  </li>
                  <li class="cursor-pointer"><a class="dropdown-item" @click="excluir(user.id)"><i class="fas fa-trash mr-2"></i>Excluir</a></li>
               </ul>
            </div>
         </div>

         <!-- Foto e nome -->
         <div class="text-center mb-3">
            <div class="profile-image mb-2">
               <img :src="user.foto || errorOnLoadImg" @error="imageError" class="rounded-perfil" width="100" height="100" alt="Foto de perfil">
            </div>
            <h5 class="mb-1 limitador font-weight-bold">{{user.nomeCompleto}}</h5>
            <small class="text-muted limitador d-block">
               <i class="far fa-envelope mr-1"></i>{{user.login}}
            </small>
         </div>

         <!-- Informações principais -->
         <div class="usuario-info">
            <div class="info-item">
               <i class="far fa-address-card mr-2 color-theme"></i>
               <span class="text-muted">{{user.cpf || '-'}}</span>
            </div>
            <div class="info-item">
               <i class="far fa-calendar mr-2 color-theme"></i>
               <span class="text-muted">{{dataNascimentoFormatada || '-'}}</span>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'Usuario',
   props: ['user', 'index'],
   computed: {
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest,
         errorOnLoadImg: state => state.errorOnLoadImg
      }),
      dataNascimentoFormatada() {
         if (!this.user.dataNascimento) return null;
         
         const data = this.user.dataNascimento;
         const dia = String(data.dayOfMonth).padStart(2, '0');
         const mes = String(data.monthValue).padStart(2, '0');
         const ano = data.year;
         
         return `${dia}/${mes}/${ano}`;
      }
   },
   methods: {
      ... mapMutations([
         'deslogar'
      ]),
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      senha : function () {
         this.$emit('senha', this.user.id)
      },
      editar : function () {
         this.$emit('editar', this.user.id)
      },
      excluir : function (id) {
         let ref = this;

         Swal.fire({
            icon: 'warning',
            title: 'Excluir usuário',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'

         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true)
               
               ref.$axios({
                  method: 'post',
                  url: ref.urlRest +'usuarios/deleteUsuario',
                  params:{
                     id: id
                  }
               }).then(function () {
                  ref.$refs.usuario.style.display = 'none'

                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Usuário excluído!'
                  })
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.deslogar()

                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        })
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     })
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false)
               })
            }
         });
      }
   }
}

</script>

<style scoped>
.usuario-card {
   transition: transform 0.2s ease, box-shadow 0.2s ease;
   position: relative;
}

.usuario-card .card-body {
   padding: 1.25rem;
   position: relative;
}

.profile-image {
   display: inline-block;
}

.profile-image img {
   height: 100px;
   width: 100px;
   object-fit: cover;
   border: 3px solid var(--primary-color);
   transition: border-color 0.2s ease;
}

.rounded-perfil {
   border-radius: 8px;
}

.usuario-info {
   border-top: 1px solid rgba(0, 0, 0, 0.1);
   padding-top: 0.75rem;
   margin-top: 0.75rem;
}

.info-item {
   display: flex;
   align-items: center;
   margin-bottom: 0.5rem;
   font-size: 0.875rem;
}

.info-item:last-child {
   margin-bottom: 0;
}

.info-item i {
   width: 18px;
   text-align: center;
}

.limitador {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 100%;
}

@media (prefers-color-scheme: dark) {
   .usuario-info {
      border-top-color: rgba(255, 255, 255, 0.1);
   }
}
</style>